import React from "react";

import Paragraph from "@common/components/Paragraph/Paragraph";
import { resolveCreationTimeString } from "@common/models/helpers/time/creationTime";
import { vars } from "@common/styles";
import { Link } from "react-router-dom";

import * as Styled from "./MessageContainer.styles";

interface Props {
  description: string;
  url?: string;
  created: string;
}

interface DescriptionParts {
  before: string;
  title: string;
  after: string;
}

// The backend's wording (fastapp issue_tracking/routes/links.py, `_log_duplicate_activity`). The
// duplicate's own entry ends with the parent's title; the parent's entries carry the duplicate's
// title between "marked "/"unmarked " and " as duplicate of this". Change one, change the other.
const DUPLICATE_OWN_ENTRY = /^(.* marked this as duplicate of )(.+)$/;
const PARENT_ENTRY = /^(.*? (?:un)?marked )(.+)( as duplicate of this)$/;

export const splitDuplicateDescription = (description: string): DescriptionParts | null => {
  const own = description.match(DUPLICATE_OWN_ENTRY);
  if (own) return { before: own[1], title: own[2], after: "" };
  const parent = description.match(PARENT_ENTRY);
  if (parent) return { before: parent[1], title: parent[2], after: parent[3] };
  return null;
};

// `activity_url` is the other ticket's absolute permalink; navigate in-app rather than reloading.
const toDashboardPath = (url?: string) => {
  if (!url) return;
  try {
    return new URL(url).pathname;
  } catch {
    return;
  }
};

export const DuplicateActivityText = ({ description, url, created }: Props) => {
  const parts = splitDuplicateDescription(description);
  const path = toDashboardPath(url);

  return (
    <Paragraph
      color={vars.colors.grey50}
      fontSize={14}
    >
      {parts && path ? (
        <>
          {parts.before}
          <Link to={path}>{parts.title}</Link>
          {parts.after}
        </>
      ) : (
        description
      )}
      .&nbsp;&nbsp;&nbsp;
      <Styled.Date>{resolveCreationTimeString(created)}</Styled.Date>
    </Paragraph>
  );
};
